// extracted by mini-css-extract-plugin
export default {"fullModal":"EditEntityModal_fullModal__IdKxB","employeeModal":"EditEntityModal_employeeModal__FEQBS"};